import { SessionStatus } from "./session";

export interface StudyOverviewDTO {
    clientId: string;
    clientName: string;
    responsiblePeople: string[];
    timeline: string;
    currentEvent: string;
    group: string;
    upcomingEvent: string;
    date: Date;
    dueDate: Date;
    overDue: Date;
    sessionId: string;
    upcomingEventStatus: StudyOverviewEventStatus;
    upcomingEventAttendeeStatus: string;
    sessionStatus: SessionStatus;
    eventStatus: EventStatus;
    isATSPostponed: boolean
    currentEventId: string;
    upcomingEventId: string;
}

export interface SessionActionDto {
    action: string;
    statusCategory: string;
}

export enum StudyOverviewEventStatus {
    PLANNED = "PLANNED",
    PROJECTED = "PROJECTED",
    OVERDUE = "OVER_DUE"
}
export const studyOverviewEventStatusValues = [
    { name: "PLANNED", value: "PLANNED" },
    { name: "PROJECTED", value: "PROJECTED" },
    { name: "OVER_DUE", value: "OVER_DUE" }
];

export enum EventStatus {
    OVERDUE = "OVERDUE",
    COMPLETED = "COMPLETED",
    IN_PROGRESS = "IN_PROGRESS",
    CLIENT_NO_SHOW_UP = "CLIENT_NO_SHOW_UP"
}

export interface DateRange {
    startDate: Date | null;
    endDate: Date | null;
}

export interface StudyOverviewQueryParams {
    page: number;
    pageSize: number;
    searchTerm?: string;
    groupFilter?: string[];
    timelineFilter?: string[];
    statusFilter?: string[];
    upcomingEventFilter?: string[];
    upcomingEventStatusFilter?: string[];
    dateRangeFilter?: DateRange;
}

export interface StudyOverviewSort {
    sortField: string;
    sortOrder: string;
}
